
import React from 'react';
import { Button } from '@/components/ui/button';
import { Save } from 'lucide-react';

interface SubmitSectionProps {
  mode: 'add' | 'edit';
  isFormValid: boolean;
  loading: boolean;
  onSubmit: () => void;
}

const SubmitSection: React.FC<SubmitSectionProps> = ({ mode, isFormValid, loading, onSubmit }) => {
  return (
    <div className="bg-white rounded-lg p-6 shadow-sm">
      {!isFormValid && (
        <p className="text-sm text-red-600 mb-4">
          Please fill in all required fields (Title, Breed, Type, and Image) before {mode === 'add' ? 'adding' : 'updating'} your listing.
        </p>
      )}
      <p className="text-sm text-gray-600 mb-4">
        Click the button below to {mode === 'add' ? 'add' : 'update'} your listing {mode === 'add' ? 'to your dashboard' : 'with the changes you\'ve made'}.
      </p>
      <Button 
        onClick={onSubmit}
        disabled={!isFormValid || loading}
        className="w-full bg-green-700 hover:bg-green-800"
      >
        {loading ? (
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
        ) : (
          <Save className="w-4 h-4 mr-2" />
        )}
        {loading ? `${mode === 'add' ? 'Adding' : 'Updating'} Listing...` : `${mode === 'add' ? 'Add' : 'Update'} Listing`}
      </Button>
    </div>
  );
};

export default SubmitSection;
